import React from "react";
import PropTypes from "prop-types";

export default class Dropdown extends React.Component {
  render() {
    const position = {
      left: "dropdown-menu-w",
      right: "dropdown-menu-e",
      topRight: "dropdown-menu-ne",
      center: "dropdown-menu-s",
      bottomLeft: "dropdown-menu-sw",
      bottomRight: "dropdown-menu-se"
    }[this.props.position];
    if (this.props.active) {
      return (
        <span className="dropdown">
          <ul className={`dropdown-menu ${position}`}>
            {React.Children.map(this.props.children, child => {
              return <li className="dropdown-item">{child}</li>;
            })}
          </ul>
        </span>
      );
    }
    return null;
  }
}

Dropdown.propTypes = {
  active: PropTypes.bool.isRequired,
  position: PropTypes.string
};

Dropdown.defaultProps = {
  position: "bottomLeft",
  active: false
};
